import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appTimeFormat]'
})
export class TimeFormatDirective {
  private formatTime(value: string): string {
    // Remove all non-numeric characters except the first ":"
    value = value.replace(/[^0-9:]/g, '');

    // Ensure only one ":" is present
    const colonIndex = value.indexOf(':');
    if (colonIndex !== -1) {
      value = value.slice(0, colonIndex + 1) + value.slice(colonIndex + 1).replace(/:/g, '');
    }

    // If there's a colon, handle formatting based on its position
    if (colonIndex !== -1) {
      const beforeColon = value.slice(0, colonIndex).replace(/\D/g, ''); // Digits before colon
      const afterColon = value.slice(colonIndex + 1).replace(/\D/g, ''); // Digits after colon

      // Ensure no more than 2 digits before the colon and 2 digits after
      const formattedBeforeColon = beforeColon.slice(-2); // Take last 2 digits before colon
      const formattedAfterColon = afterColon.slice(0, 2); // Take first 2 digits after colon

      return `${formattedBeforeColon}:${formattedAfterColon}`;
    }

    // If no colon, format as "HH:MM" after 2 digits
    const numbersOnly = value.replace(/\D/g, '');
    if (numbersOnly.length > 4) {
      value = numbersOnly.slice(0, 4);
    }

    if (numbersOnly.length > 2) {
      return `${numbersOnly.slice(0, 2)}:${numbersOnly.slice(2)}`;
    }

    return numbersOnly;
  }

  @HostListener('keydown', ['$event'])
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;

    // Format value
    let formattedValue = this.formatTime(inputElement.value);

    if (formattedValue.length > 5) {
      formattedValue = formattedValue.slice(0, 5);
    }

    // Prevent cursor jumping
    inputElement.value = formattedValue;
  }
}
